import React from "react";
import {
  BandSection,
  BandInner,
  BandHeading,
  BandBody
} from "./styled.components";

const NobodyDieBand: React.FC = () => (
  <BandSection>
    <BandInner>
      <BandHeading>Nobody Else Needs to Die.</BandHeading>
      <BandBody>
        Food allergy awareness saves lives. The Kyah Rayne Foundation is
        dedicated to training students, teachers, and families to recognize and
        respond to food allergies and anaphylaxis. We&rsquo;re working to
        increase access to life-saving epinephrine with the goal of preventing
        food allergy fatalities.
      </BandBody>
    </BandInner>
  </BandSection>
);

export default NobodyDieBand;
